import Swal from "sweetalert2";
import './sweetAlertClasses.css'

export default function useModals () {

    const modal = async (text,title, onConfirmFunction) => {
        Swal.fire({
            text: text,
            title: title,
            showCancelButton: true,
            confirmButtonText: 'Accept',
            color: 'black',
            confirmButtonColor: '#43a1a2',
            background: 'rgb(255,255,255)',
            focusConfirm: false,
            customClass: {
                popup: 'modalContainer',
            },
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
                `
            },
              hideClass: {
                popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `
            }
        }).then(async(result) => {
            if (result.isConfirmed) {
                onConfirmFunction()
            }
        })
    }

   
    return {
        modal,
    }
}
